import axios from 'axios';
import { API } from '../global/global';

export interface Geocerca {
  id: number;
  nombre: string;
  descripcion?: string;
  tipo: 'circular' | 'poligonal';
  centro_latitud?: number;
  centro_longitud?: number;
  radio?: number;
  coordenadas?: Array<{lat: number, lng: number}>;
  color: string;
  activa: boolean;
  accion_entrada: 'notificar' | 'bloquear' | 'registrar';
  accion_salida: 'notificar' | 'bloquear' | 'registrar';
  usuario_creacion_id: number;
  estatus: boolean;
  created_at: string;
  updated_at: string;
}

export interface CrearGeocercaRequest {
  nombre: string;
  descripcion?: string;
  tipo: 'circular' | 'poligonal';
  centro_latitud?: number;
  centro_longitud?: number;
  radio?: number;
  coordenadas?: Array<{lat: number, lng: number}>;
  color?: string;
  accion_entrada?: 'notificar' | 'bloquear' | 'registrar';
  accion_salida?: 'notificar' | 'bloquear' | 'registrar';
}

export const obtenerGeocercas = async (token: string): Promise<Geocerca[]> => {
  const response = await axios.get(`${API}/geocercas`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data.data;
};

export const crearGeocerca = async (geocerca: CrearGeocercaRequest, token: string): Promise<Geocerca> => {
  const response = await axios.post(`${API}/geocercas`, geocerca, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data.data;
};

export const obtenerGeocerca = async (id: number, token: string): Promise<Geocerca> => {
  const response = await axios.get(`${API}/geocercas/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data.data;
};

export const actualizarGeocerca = async (id: number, geocerca: Partial<CrearGeocercaRequest>, token: string): Promise<Geocerca> => {
  const response = await axios.put(`${API}/geocercas/${id}`, geocerca, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data.data;
};

export const eliminarGeocerca = async (id: number, token: string): Promise<void> => {
  await axios.delete(`${API}/geocercas/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};

export const obtenerEstadisticasGeocercas = async (token: string) => {
  const response = await axios.get(`${API}/geocercas/estadisticas`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data.data;
};
